import { AllKycScreenRouteNames } from './config'
import { INVALID_NAVLINK } from './errors'
import getRouteFromNavLink from './get-route-from-navlink'

// TECH Todo: this function is almost similar to get-route-from-navlink. See how to make the core logic reusable.
export default function getKycRouteNameFromUrl(navlink: string) {
  const routeName = navlink.split('kyc/')[1]

  /**
   * TechTODO: use react-error-boundary component to handle this error and show appropriate UI
   */
  if (!routeName) {
    throw new Error(INVALID_NAVLINK)
  }

  // TechTODO: see if 'ivr-screen' or any other such 'out of navlink' screen starts getting repeated. If yes, abstract it in types and utility functions properly
  // TechTODO: figure out a type guard for this if that makes sense
  return routeName as AllKycScreenRouteNames
}

export function getKycRouteFromUrl(url: string) {
  return getRouteFromNavLink(url)
}
